







import TopNav from './components/TopNav.vue'
import { createComponent, onMounted } from '@vue/composition-api'
import { provideStore, provideRoute, provideRouter } from '@/hooks/common'
import IsElectron from 'is-electron'
import { Message, MessageBox } from 'element-ui'
import { electronDownload, getUrlArgs } from './helpers/common'
export default createComponent({
    components: {
        TopNav,
    },
    setup(props, { root: { $store: store, $router: router, $route: route } }) {
        provideStore(store)
        provideRouter(router)
        provideRoute(route)
        onMounted(async () => {
            if (IsElectron()) {
                (window as any).Ait.fileSystem.on('error', (e, data) => {
                    // console.log(e)
                    // console.log(data)
                    (Message as any).closeAll()
                    Message.error(data.data)
                })
                ;(window as any).Ait.fileSystem.on('message', (e, data) => {
                    (Message as any).closeAll()
                    if (Message[data.type]) {
                        Message[data.type](data.data)
                    } else {
                        Message.info(data.data)
                    }
                })
                ;(window as any).Ait.fileSystem.on('changeRoute', (e, data) => {
                    // console.log(e)
                    // console.log(data.data)
                    window.location.href = data.data
                })
                // const { fs_download_params } = getUrlArgs();
                const params = getUrlArgs()
                // console.log(params)
                const { fs_download_params } = params
                if (fs_download_params) {
                    try {
                        const downloadData = JSON.parse(fs_download_params as string)
                        try {
                            const query = Object.assign({}, router.currentRoute.query, {
                                fs_download_params: '',
                                _: Date.now(),
                            })
                            router.replace({
                                query: query,
                            })
                            await MessageBox.confirm(`发现下载任务"${downloadData.name}"，是否开始下载？`, '提示', {
                                cancelButtonText: '取消',
                                confirmButtonText: '下载',
                            })
                            electronDownload(downloadData, router)
                        } catch (error) {
                            console.log(error)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
            }
        })
    },
})
